export const isNullOrSpaces = (str) => {
  return str === null || str === undefined || str.match(/^ *$/) !== null;
};

export const hasTwoWords = (str) => {
  const words = str.trim().split(/\s+/);
  return words.length >= 2 && words.every(mot => mot !== '');
}